import { Icon, IconProps } from '@chakra-ui/react'

export default function HammerIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4485 4.46519L10.7037 2.72047C10.2409 2.2576 9.61322 1.99756 8.95868 1.99756C8.30414 1.99756 7.67641 2.2576 7.21362 2.72047L6.43129 3.50279C6.34299 3.59092 6.31654 3.7236 6.36431 3.83886C6.41207 3.95411 6.52462 4.02918 6.64938 4.02901H7.13892C7.46612 4.02914 7.77989 4.15915 8.01128 4.3905L8.52216 4.90137V5.7744L9.83137 7.08295L10.505 6.88287L11.1399 7.51713V8.38949L11.5147 8.76432C11.7898 9.03918 12.2355 9.03918 12.5105 8.76432L14.1318 7.14231C14.2642 7.01041 14.3385 6.83127 14.3385 6.64443C14.3385 6.4576 14.2642 6.27846 14.1318 6.14656L13.7577 5.7724H12.8846L12.2504 5.13747L12.4485 4.46519Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.12559 13.539V13.539C2.43875 13.852 2.86869 14.0196 3.3111 14.0011C3.75351 13.9826 4.16796 13.7797 4.45389 13.4416L9.83146 7.08296L8.52225 5.77441L2.21029 11.2207C1.87715 11.5083 1.67875 11.9216 1.66268 12.3614C1.64661 12.8012 1.81432 13.2278 2.12559 13.539Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
